import React from 'react'
import PropTypes from 'prop-types'
import { useWindowWidth } from './MPGridUtils'

function MPGridColumn (props) {
  /*
    * Empty 'width' will cause it to render in the full width of a row
    * Respect the constrained PropTypes of width and alignItems
  */

  const columnStyle = {
    display: 'flex',
    width: '100%',
    flexDirection: 'column'
  }

  const alignItemsStyle = props.alignItems ? { alignItems: `${props.alignItems}` } : ''
  const centerStyle = props.center ? { margin: '0 auto' } : ''
  const inheritedStyles = props.style ? props.style : ''
  let widthStyle = ''

  if (useWindowWidth() >= 1060 && props.width) {
    widthStyle = (props.width === 'one-third') ? {
      maxWidth: 320
    } : {
      maxWidth: props.width * 80 + (props.width - 1) * 60
    }
  }

  return (
    <div id={props.id} style={{ ...columnStyle, ...widthStyle, ...alignItemsStyle, ...centerStyle, ...inheritedStyles }}>
      {props.children}
    </div>
  )
}

MPGridColumn.propTypes = {
  width: PropTypes.oneOf([2, 3, 'one-third', 4, 5, 6, 8]),
  alignItems: PropTypes.oneOf(['flex-start', 'center', 'flex-end']),
  center: PropTypes.bool,
  children: PropTypes.node,
  style: PropTypes.object,
  id: PropTypes.string
}

export default MPGridColumn
